import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

// Controller for individual field updates via Turbo
export default class extends Controller {
  static values = { 
    url: String,
    field: String,
    method: { type: String, default: "PATCH" }
  }

  connect() {
    // If no URL provided or URL is empty, disable turbo functionality for new records
    if (!this.hasUrlValue || this.urlValue === "" || this.urlValue === null) {
      console.log(`Turbo field disabled for new record - field: ${this.fieldValue}`)
      // Remove the controller to prevent any turbo functionality
      this.element.removeAttribute("data-controller")
      return
    }
    
    console.log(`Turbo field connected for: ${this.fieldValue}`)
  }

  // Called when field value changes
  async updateField(event) {
    const field = event.target
    const fieldName = field.name
    const fieldValue = field.type === 'checkbox' ? field.checked : field.value
    
    console.log(`Updating ${fieldName}: ${fieldValue}`)
    
    // Create form data with just this field
    const formData = new FormData()
    formData.append(fieldName, fieldValue)
    formData.append("turbo_frame", `field_${this.fieldValue}`)
    
    try {
      const response = await fetch(this.urlValue, {
        method: this.methodValue,
        body: formData,
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.content,
          'Accept': 'text/vnd.turbo-stream.html, text/html'
        }
      })

      if (!response.ok) {
        console.error(`Failed to update ${fieldName}`)
      }
    } catch (error) {
      console.error(`Error updating field: ${error}`)
    }
  }

  // For select dropdowns and date fields - update on change
  fieldChanged(event) {
    this.updateField(event)
  }

  // For text fields - update on blur (when user leaves field)
  fieldBlurred(event) {
    // Skip if value hasn't changed
    if (event.target.dataset.originalValue === event.target.value) {
      return
    }
    
    this.updateField(event)
    // Store new value as original for next comparison
    event.target.dataset.originalValue = event.target.value
  }
}